import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { useStyles } from '../../Dashboard.styles';
import { DashboardType } from '../../Dashboard.types';

interface SwitchDashboardTypeButtonsProps {
  onSwitchDashboardType: (type: DashboardType) => void;
  activeDashboardType: DashboardType;
}

export const SwitchDashboardTypeButtons: React.FC<SwitchDashboardTypeButtonsProps> = ({
  activeDashboardType,
  onSwitchDashboardType,
}) => {
  const styles = useStyles();

  return (
    <ButtonGroup size="small" className={styles.SwitchDashboardTypeButtons}>
      <Button
        onClick={() => onSwitchDashboardType('assessment')}
        style={{
          color: activeDashboardType === 'assessment' ? '#3C419A' : '#FFFFFF',
          background: activeDashboardType === 'assessment' ? '#FFFFFF' : 'none',
          border: 'none',
        }}
        aria-pressed={activeDashboardType === 'assessment'}
      >
        Sesje egzaminacyjne
      </Button>
      <Button
        onClick={() => onSwitchDashboardType('training')}
        style={{
          color: activeDashboardType === 'training' ? '#347F42' : '#FFFFFF',
          background: activeDashboardType === 'training' ? '#FFFFFF' : 'none',
          border: 'none',
        }}
        aria-pressed={activeDashboardType === 'training'}
      >
        Sesja treningowa
      </Button>
    </ButtonGroup>
  );
};
